<div class="cell widget" [ngClass]="{ 'edit-dashboard' : editDashboard === true }">
  <h3 class="title-bar h5">{{widget?.title}}</h3>

  <div>
    @switch (widget?.component) {
      @case ('Grid') {
        <grid-widget [widgetTitle]="widget?.title"></grid-widget>
      }
      @case ('Chart') {
        <chart-widget [widgetTitle]="widget?.title"></chart-widget>
      }
      @case ('Map') {
        <map-widget [latitude]="-82.9988" [longitude]="39.9612" [widgetTitle]="widget?.title"></map-widget>
      }
      @case ('WorkOrder') {
        <work-order-widget [widgetTitle]="widget?.title"></work-order-widget>
      }
      @case ('FullCalendar') {
        <rics-full-calendar [currentView]="calendarTypes.Month"></rics-full-calendar>
      }
      @case ('ListCalendar') {
        <rics-full-calendar [currentView]="calendarTypes.ListWeek"></rics-full-calendar>
      }
      @case ('RegistrationRequest') {
        <registration-request [widgetTitle]="widget?.title"></registration-request>
      }
      @case ('Permits') {
        <permits-widget [widgetTitle]="widget?.title"></permits-widget>
      }
      @case ('FinancialAssurance') {
        <fa-external-widget [widgetTitle]="widget?.title"></fa-external-widget>
      }
      @case ('FinancialAssuranceInternal') {
        <fa-internal-widget [widgetTitle]="widget?.title"></fa-internal-widget>
      }
      @case ('ExternalPermit') {
        <ext-permit-widget [widgetTitle]="widget?.title"></ext-permit-widget>
      }
      <!--<ext-work-order-widget *ngSwitchCase="'ExternalWorkOrder'" [widgetTitle]="widget?.title"></ext-work-order-widget>-->
      @case ('Scanning') {
        <scanning-widget [widgetTitle]="widget?.title"></scanning-widget>
      }
      @case ('PendingMail') {
        <pending-mail-widget [widgetTitle]="widget?.title"></pending-mail-widget>
      }
      @case ('PendingPayments') {
        <pending-payments-widget [widgetTitle]="widget?.title"></pending-payments-widget>
      }
      @case ('Wells') {
        <well-widget [widgetTitle]="widget?.title"></well-widget>
      }
      @case ('ExternalChiefsOrdersStatus') {
        <ext-chiefs-order-status [widgetTitle]="widget?.title"></ext-chiefs-order-status>
      }
      @case ('OrgFiles') {
        <org-files-widget [widgetTitle]="widget?.title"></org-files-widget>
      }
      @case ('PendingWellTransfer') {
        <pending-well-transfer-widget [widgetTitle]="widget?.title"></pending-well-transfer-widget>
      }
      @case ('InternalInspections') {
        <inspections-internal [widgetTitle]="widget?.title"></inspections-internal>
      }
      @case ('InternalUpcomingBondExpiration') {
        <internal-upcoming-bond-expiration-widget [widgetTitle]="widget?.title"></internal-upcoming-bond-expiration-widget>
      }
      @case ('WellSellerTransfer') {
        <well-transfer-seller-widget [widgetTitle]="widget?.title"></well-transfer-seller-widget>
      }
      @case ('WellBuyerTransfer') {
        <wt-buyer-widget [widgetTitle]="widget?.title"></wt-buyer-widget>
      }
      @case ('ExternalPayments') {
        <external-payments-widget [widgetTitle]="widget?.title"></external-payments-widget>
      }
      @case ('Notifications') {
        <notifications-widget [widgetTitle]="widget?.title"></notifications-widget>
      }
      @case ('Utility') {
        <utility-widget [widgetTitle]="widget?.title"></utility-widget>
      }
      @case ('External7ATransfer') {
        <ext-7a-transfer-widget [widgetTitle]="widget?.title"></ext-7a-transfer-widget>
      }
      <!--<issues-widget *ngSwitchCase="'Issues'" [widgetTitle]="widget?.title"></issues-widget>-->
      @case (widgetKinds.Issues) {
        <issues-view [widgetTitle]="widget?.title"></issues-view>
      }
      @case ('DataCorrections') {
        <data-corrections-widget [widgetTitle]="widget?.title"></data-corrections-widget>
      }
      @case ('ExternalDataCorrectionRequests') {
        <data-correction-requests-external-widget [widgetTitle]="widget?.title"></data-correction-requests-external-widget>
      }
      @case ('InternalDataCorrectionRequests') {
        <data-correction-requests-internal-widget [widgetTitle]="widget?.title"></data-correction-requests-internal-widget>
      }
      @case (widgetKinds.PaperSubmissions) {
        <paper-submissions-widget [widgetTitle]="widget?.title"></paper-submissions-widget>
      }
      @case (widgetKinds.ExternalOrganizationManagement) {
        <organization-management-external-widget [widgetTitle]="widget?.title"></organization-management-external-widget>
      }
      @case (widgetKinds.InternalOrganizationManagement) {
        <organization-management-internal-widget [widgetTitle]="widget?.title"></organization-management-internal-widget>
      }
      @case (widgetKinds.InternalComplianceReport) {
        <compliance-reports-internal-view [widgetTitle]="widget?.title"></compliance-reports-internal-view>
      }
      @case (widgetKinds.ExternalComplianceReport) {
        <compliance-reports-external-view [widgetTitle]="widget?.title"></compliance-reports-external-view>
      }
      @case (widgetKinds.ExternalIssues) {
        <external-issues-view [widgetTitle]="widget?.title"></external-issues-view>
      }
      @case (widgetKinds.WellSearch) {
        <well-search-view [widgetTitle]="widget?.title"></well-search-view>
      }
      @case (widgetKinds.LandownerPassthrough) {
        <landowner-passthrough-view [widgetTitle]="widget?.title"></landowner-passthrough-view>
      }
    }
  </div>

  <!--
  <div class="widget-bottom-links">
    <a class="small-font-size float-right">More info &raquo;</a>
  </div>
  -->
</div>